export const ITEMS_PER_PAGE = 10
export const LOAD_BATCH_SIZE = 100

export const STATE_NAME_TO_ABBR = {
  Acre: 'AC',
  Alagoas: 'AL',
  Amapá: 'AP',
  Amazonas: 'AM',
  Bahia: 'BA',
  Ceará: 'CE',
  'Distrito Federal': 'DF',
  'Espírito Santo': 'ES',
  Goiás: 'GO',
  Maranhão: 'MA',
  'Mato Grosso': 'MT',
  'Mato Grosso do Sul': 'MS',
  'Minas Gerais': 'MG',
  Pará: 'PA',
  Paraíba: 'PB',
  Paraná: 'PR',
  Pernambuco: 'PE',
  Piauí: 'PI',
  'Rio de Janeiro': 'RJ',
  'Rio Grande do Norte': 'RN',
  'Rio Grande do Sul': 'RS',
  Rondônia: 'RO',
  Roraima: 'RR',
  'Santa Catarina': 'SC',
  'São Paulo': 'SP',
  Sergipe: 'SE',
  Tocantins: 'TO',
  Brasil: 'BR',
}

export const BRAZILIAN_STATES = [
  { value: '', label: 'Todos os estados' },
  { value: 'Brasil', label: 'Brasil' },
  { value: 'Acre', label: 'Acre' },
  { value: 'Alagoas', label: 'Alagoas' },
  { value: 'Amapá', label: 'Amapá' },
  { value: 'Amazonas', label: 'Amazonas' },
  { value: 'Bahia', label: 'Bahia' },
  { value: 'Ceará', label: 'Ceará' },
  { value: 'Distrito Federal', label: 'Distrito Federal' },
  { value: 'Espírito Santo', label: 'Espírito Santo' },
  { value: 'Goiás', label: 'Goiás' },
  { value: 'Maranhão', label: 'Maranhão' },
  { value: 'Mato Grosso', label: 'Mato Grosso' },
  { value: 'Mato Grosso do Sul', label: 'Mato Grosso do Sul' },
  { value: 'Minas Gerais', label: 'Minas Gerais' },
  { value: 'Pará', label: 'Pará' },
  { value: 'Paraíba', label: 'Paraíba' },
  { value: 'Paraná', label: 'Paraná' },
  { value: 'Pernambuco', label: 'Pernambuco' },
  { value: 'Piauí', label: 'Piauí' },
  { value: 'Rio de Janeiro', label: 'Rio de Janeiro' },
  { value: 'Rio Grande do Norte', label: 'Rio Grande do Norte' },
  { value: 'Rio Grande do Sul', label: 'Rio Grande do Sul' },
  { value: 'Rondônia', label: 'Rondônia' },
  { value: 'Roraima', label: 'Roraima' },
  { value: 'Santa Catarina', label: 'Santa Catarina' },
  { value: 'São Paulo', label: 'São Paulo' },
  { value: 'Sergipe', label: 'Sergipe' },
  { value: 'Tocantins', label: 'Tocantins' },
]

export function fetchStateNameByAbbreviation(uf: string) {
  return Object.keys(STATE_NAME_TO_ABBR)[
    Object.values(STATE_NAME_TO_ABBR).findIndex(item => item === uf.toUpperCase())
  ]
}
